module.exports = __webpack_public_path__ + "img/nezamsenfi.47ae86a.svg";